import { SAME_SITE_STRICT } from '@constants/cookies';
import Cookies from 'js-cookie';

import { REFRESH_TOKEN_KEY, STORAGE_IMPERSONATE_REFRESH_TOKEN_KEY, STORAGE_REFRESH_TOKEN_KEY } from './constants';
import { cookieDomain } from './constants';

const maxDaysRefreshToken = 90;

export const setRefreshToken = ({ key, token }: { key: string; token: string }) => {
  Cookies.set(key, token, {
    domain: cookieDomain,
    path: '/',
    sameSite: SAME_SITE_STRICT,
    secure: true,
    expires: maxDaysRefreshToken,
  });
  const storageKey: string =
    key === REFRESH_TOKEN_KEY ? STORAGE_REFRESH_TOKEN_KEY : STORAGE_IMPERSONATE_REFRESH_TOKEN_KEY;
  localStorage.setItem(storageKey, token);
};
